import React from "react";

const P = {
    instagram: "M12 2.2c3.2 0 3.6 0 4.8.1 1.2.1 1.8.2 2.2.4.6.2 1 .5 1.4.9.4.4.7.8.9 1.4.2.4.4 1 .4 2.2.1 1.3.1 1.6.1 4.8s0 3.6-.1 4.8c-.1 1.2-.2 1.8-.4 2.2-.2.6-.5 1-.9 1.4-.4.4-.8.7-1.4.9-.4.2-1 .4-2.2.4-1.3.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-1.2-.1-1.8-.2-2.2-.4-.6-.2-1-.5-1.4-.9-.4-.4-.7-.8-.9-1.4-.2-.4-.4-1-.4-2.2C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.8c.1-1.2.2-1.8.4-2.2.2-.6.5-1 .9-1.4.4-.4.8-.7 1.4-.9.4-.2 1-.4 2.2-.4C8.4 2.2 8.8 2.2 12 2.2zm0 4.6a5.2 5.2 0 100 10.4 5.2 5.2 0 000-10.4zm0 8.6a3.4 3.4 0 110-6.8 3.4 3.4 0 010 6.8zm5.4-9.9a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4z",
    linkedin: "M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 110-4.13 2.06 2.06 0 010 4.13zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z",
    tiktok: "M19.6 6.7a4.8 4.8 0 01-3.8-4.2V2h-3.4v13.4a2.9 2.9 0 11-2-2.7V9.2a6.3 6.3 0 105.4 6.2V8.6a8.2 8.2 0 004.8 1.5V6.7h-1z",
    x: "M18.24 2.25h3.31l-7.23 8.26 8.5 11.24h-6.66l-5.21-6.82-5.97 6.82H1.67l7.73-8.84L1.25 2.25h6.83l4.71 6.23 5.45-6.23zm-1.16 17.52h1.83L7.08 4.13H5.12l11.96 15.64z",
    facebook: "M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.7 4.53-4.7 1.31 0 2.69.24 2.69.24v2.97h-1.52c-1.49 0-1.96.93-1.96 1.89v2.26h3.33l-.53 3.49h-2.8V24C19.61 23.1 24 18.1 24 12.07z",
    youtube: "M23.5 6.2a3 3 0 00-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 00.5 6.2 31 31 0 000 12a31 31 0 00.5 5.8 3 3 0 002.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 002.1-2.1A31 31 0 0024 12a31 31 0 00-.5-5.8zM9.6 15.6V8.4l6.3 3.6-6.3 3.6z",
};

export const SOCIAL_PLATFORMS = [
    { k: "instagram", label: "Instagram", key: "social_instagram", domains: ["instagram.com"] },
    { k: "linkedin", label: "LinkedIn", key: "social_linkedin", domains: ["linkedin.com"] },
    { k: "tiktok", label: "TikTok", key: "social_tiktok", domains: ["tiktok.com"] },
    { k: "x", label: "X (formerly Twitter)", key: "social_x", domains: ["x.com", "twitter.com"] },
    { k: "facebook", label: "Facebook", key: "social_facebook", domains: ["facebook.com", "fb.com"] },
    { k: "youtube", label: "YouTube", key: "social_youtube", domains: ["youtube.com", "youtu.be"] },
];

export function SocialGlyph({ k, className = "h-4 w-4" }) {
    return <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true"><path d={P[k]} /></svg>;
}

export function validSocialUrl(url, domains) {
    try {
        const u = new URL(url);
        const h = u.hostname.toLowerCase();
        return u.protocol === "https:" && domains.some((d) => h === d || h.endsWith(`.${d}`));
    } catch { return false; }
}

export function SocialLinks({ settings, tone = "dark", testid = "socials" }) {
    if (!settings) return null;
    const items = SOCIAL_PLATFORMS.filter((p) => settings[`${p.key}_enabled`] !== false && validSocialUrl(settings[p.key] || "", p.domains));
    if (!items.length) return null;
    const cls = tone === "dark"
        ? "border-white/20 text-white/85 hover:bg-lnl-gold hover:text-lnl-charcoal focus-visible:ring-lnl-gold"
        : "border-lnl-border text-lnl-charcoal hover:bg-lnl-green hover:text-white focus-visible:ring-lnl-green";
    return (
        <div className="flex flex-wrap items-center gap-2" data-testid={testid}>
            {items.map((p) => (
                <a key={p.k} href={settings[p.key]} target="_blank" rel="noopener noreferrer" aria-label={`${p.label} (opens in a new tab)`}
                    data-testid={`${testid}-${p.k}`}
                    className={`w-9 h-9 grid place-items-center rounded-md border transition-colors focus:outline-none focus-visible:ring-2 ${cls}`}>
                    <SocialGlyph k={p.k} />
                </a>
            ))}
        </div>
    );
}

export function ContactEmails({ settings, iconClass, Icon, linkClass = "", testid = "contact-emails" }) {
    const emails = [settings?.email_info, settings?.email_registrar].filter(Boolean);
    return (
        <>
            {emails.map((e, i) => (
                <div key={e} className="flex items-center gap-2" data-testid={`${testid}-${i === 0 ? "info" : "registrar"}`}>
                    {Icon && <Icon className={iconClass} />}
                    <a className={`hover:underline break-all ${linkClass}`} href={`mailto:${e}`}>{e}</a>
                </div>
            ))}
        </>
    );
}
